import React, { useState, useContext, useMemo } from "react";
import { Route, Switch } from "react-router-dom";
import Profile from "./components/profile/Profile";
import Login from "./components/login";
import ForgotPassword from "./components/forgotpassword";
import Lockscreen from "./components/lockscreen";
import { Appcontext } from "../approuter";
import Projects from "./components/projects/Projects";
import SuperAdminRoutes from "../routes/SuperAdminRoutes";
import ServiceProvidersList from "./components/serviceProviders/ServiceProvidersList";
import SubAdminList from "./components/subadmins/SubAdmins";
import AdminRoleManagement from "./components/rolesAndPermissions/RolesManagement";
import AdminDashboard from "./components/dashboard/AdminDashboard";

const AppUniversal = function (props) {
  const { isAuth, setIsAuth } = useContext(Appcontext);

  const location = props?.location;

  useMemo(() => {
    if (
      location?.pathname == "/login" ||
      location?.pathname == "/admin/register" ||
      location?.pathname == "/admin/forgotPassword" ||
      location?.pathname == "/admin/lockscreen" ||
      location?.pathname == "/admin/conform-email" ||
      location?.pathname == "/admin/404" ||
      location?.pathname == "/admin/500"
    ) {
      setIsAuth("admin");
    } else {
      setIsAuth("user");
    }
  }, [location]);

  return (
    <Switch>
      <Route path="/admin/forgotPassword" exact component={ForgotPassword} />
      <Route path="/admin/lockscreen" exact component={Lockscreen} />
      <SuperAdminRoutes path="/admin" exact component={AdminDashboard} />
      <SuperAdminRoutes path="/admin/subadmins" exact component={SubAdminList} />
      <SuperAdminRoutes path="/admin/users-list" exact component={ServiceProvidersList} />
      <SuperAdminRoutes path="/admin/projects" exact component={Projects} />
      <SuperAdminRoutes path="/admin/roles" exact component={AdminRoleManagement} />
      <Route path="/admin/profile" exact component={Profile} />
    </Switch>
  );
};

export default AppUniversal;
